PMW.mergePMW(PMW, {
  PAYMENT_VENDORS: {
    APPLE: 'apple',
    STRIPE: 'stripe',
  },
  IAP_PRODUCT_TYPES: {
    DOWNLOADS: 'downloads',
    CREDITS: 'credits',
    SUBSCRIPTIONS: 'subscriptions',
    FREE_TRIALS: 'freeTrials'
  },
  callBackForIAPurchase: function(productId, purchaseType, successCb, errorCb) {
    if (window.webkit && window.webkit.messageHandlers) {
      PMW.writeLocal('user/getAppleCustomerIdByUserId').then(appleAccountToken => {
        window.webkit.messageHandlers.purchaseResponse.postMessage({
          itemId: productId,
          appleAccountToken: appleAccountToken,
          purchaseType: purchaseType,
        });
      }).catch(() => {
        errorCb();
      });
      const handler = async (event) => {
        if (event.detail.message.status === 'success') {
          successCb(event.detail.message);
        } else {
          errorCb(event.detail.message.status !== 'cancelled');
        }
        document.removeEventListener('purchaseResponse', handler);
      };
      document.addEventListener('purchaseResponse', handler);
    } else {
      PMW.openErrorModal({log: false});
    }
  },
  getIAPProducts: async function(type, cb) {
    await new Promise((resolve, reject) => {
      const products = PMW.getVersionedCacheItem(type);
      if (products) {
        cb(products);
        resolve();
        return
      }
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.productsResponse.postMessage({
          purchaseType: type,
        });
        const handler = (event) => {
          const products = event.detail.message;
          if (products) {
            let decodedProducts = JSON.parse('[' + products.replaceAll('[', '{').replaceAll(']', '}').slice(1, products.length - 1) + ']');
            decodedProducts = decodedProducts.map((product) => {
              return {
                ...product,
                tierId: Number(product.tierId),
                duration: Number(product.duration),
                level: Number(product.level),
              }
            })
            PMW.setCacheItem(type, products, PMW.CACHE_EXPIRY_ONE_HOUR);
            cb(decodedProducts);
            resolve();
          }
          document.removeEventListener('productsResponse', handler);
        };
        document.addEventListener('productsResponse', handler);
      } else {
        PMW.openErrorModal({log: false});
        reject();
      }
    });
  },
  openIOSDeviceSubscriptions: function() {
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit.messageHandlers.subscriptionSettings.postMessage({});
      const handler = (event) => {
        if (event.detail.message === 'error') {
          PMW.openMessageModal({
            text: i18next.t('pmwjs_manage_ios_subscription')
          })
        }
        document.removeEventListener('subscriptionSettings', handler);
      };
      document.addEventListener('subscriptionSettings', handler);
    } else {
      PMW.openErrorModal({log: false});
    }
  },
  openIOSDevicePurchaseHistory: function() {
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit.messageHandlers.purchaseHistory.postMessage({});
      const handler = (event) => {
        if (event.detail.message === 'error') {
          PMW.openMessageModal({
            text: i18next.t('pmwjs_you_can_view_your_purchase_history_from_settings_or_app_store')
          })
        }
        document.removeEventListener('purchaseHistory', handler);
      };
      document.addEventListener('purchaseHistory', handler);
    } else {
      PMW.openErrorModal({log: false});
    }
  },
  showSubscriptionHandlingInfo: async () => {
    const userId = PMW.getUserId();
    if (!userId || !PMW.isUserPremium()) {
      return false;
    }
    const vendor = await PMW.readLocal('premium/getActiveSubscriptionVendor', null, 'activeSubscriptionVendor'+userId);
    const showManageSubscriptionsDialog = (vendor === PMW.PAYMENT_VENDORS.APPLE && !PMW.isIOSApp()) || (vendor === PMW.PAYMENT_VENDORS.STRIPE && PMW.isIOSApp());
    if (showManageSubscriptionsDialog) {
      PMW.openMessageModal({
        title: i18next.t('pmwjs_manage_subscription'),
        text: i18next.t(PMW.isIOSApp() ? 'pmwjs_manage_subscription_web_or_android' : 'pmwjs_manage_subscription_ios_ipados'),
        ctaButton: {
          text: i18next.t('pmwjs_okay'),
          onClick: () => {
            PMW.closeMessageModal();
          },
        },
      });
      return true;
    }
    return false;
  }
});